import React,{ Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Actions from '../../../../../Actions';
import { getStatus, sanitizeData } from '../../../../../Utilities/Common';

class RowShallow extends Component{

    render(){
        let {vanity_id:id, location,type,priority,status,problem,HS,user,created_at,comment,image } = sanitizeData(this.props.job);
        const jobStatus = getStatus(status);
        return (
            <div className="p-3 mb-3 border">
            <Table responsive hover bordered className="text-center">
                <thead>
                    <tr>
                        <th>Niggle</th><th>Type</th><th>H&amp;S</th><th>Age</th><th>Location</th><th>Status</th><th>Priority</th><th>Created By</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{id}</td><td>{type.name}</td><td>{HS === 1 ? <span style={{color:"red",fontWeight:"bold"}}>YES</span>: "No"}</td><td>{created_at}</td><td>{location.name}</td><td style={{backgroundColor: jobStatus.color}}>{jobStatus.name}</td><td>{priority === 1 ? <span style={{color:"red",fontWeight:"bold"}}>URGENT</span>: "Medium"}</td><td>{user.name}</td>
                    </tr>
                </tbody>
            </Table>
                <b>Problem:</b> {problem}<br/>
                <b>Comment:</b> {comment}<br/>
                {!image.includes("default.jpg") && <React.Fragment><img width="250px" height="250px" src={image} /><br/></React.Fragment>}
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.jobs)(RowShallow);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/Handyman/Level_1/RowShallow.js